import script from "./tickets-filter-filter-menu.vue?vue&type=script&setup=true&lang=ts"
export * from "./tickets-filter-filter-menu.vue?vue&type=script&setup=true&lang=ts"

const __exports__ = script;

export default __exports__